import React, { useState } from 'react';
import { Typography, Breadcrumb, Card, Radio, List, Button, Space, message } from 'antd';

const { Title, Paragraph } = Typography;

const plans = [
  { key: 'basic', name: 'Basic', price: '$49 / month', features: ['Up to 3 campaigns', 'Email support'] },
  { key: 'pro', name: 'Pro', price: '$199 / month', features: ['Unlimited campaigns', 'Priority support', 'Advanced analytics'] },
  { key: 'enterprise', name: 'Enterprise', price: 'Custom', features: ['SLA', 'Dedicated manager', 'SSO'] },
];

const UpgradePlan = () => {
  const [selected, setSelected] = useState('pro');
  const [loading, setLoading] = useState(false);

  const onChangePlan = async () => {
    setLoading(true);
    // POST /api/client/billing/change-plan
    await new Promise(r => setTimeout(r, 400));
    setLoading(false);
    message.success(`Plan changed to ${selected.toUpperCase()}`);
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Billing' }, { title: 'Upgrade/Downgrade' }]} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Upgrade/Downgrade Plan</Title>
        <Space>
          <Button type="primary" onClick={onChangePlan} loading={loading}>Confirm Change</Button>
        </Space>
      </div>

      <Card>
        <Paragraph type="secondary">Select your desired plan.</Paragraph>
        <Radio.Group value={selected} onChange={(e) => setSelected(e.target.value)} style={{ width: '100%' }}>
          <List
            itemLayout="vertical"
            dataSource={plans}
            renderItem={(p) => (
              <List.Item onClick={() => setSelected(p.key)} style={{ cursor: 'pointer' }}>
                <Radio value={p.key}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                    <div>
                      <div style={{ fontWeight: 600 }}>{p.name}</div>
                      <div style={{ color: '#666' }}>{p.features.join(' • ')}</div>
                    </div>
                    <div style={{ fontWeight: 600 }}>{p.price}</div>
                  </div>
                </Radio>
              </List.Item>
            )}
          />
        </Radio.Group>
      </Card>
    </div>
  );
};

export default UpgradePlan;
